<script>
  import Item from './Item.svelte';

  export let list;
</script>

<div class="table-container">
  <table class="table is-bordered is-fullwidth is-hoverable">
    <thead class="thead is-bold">
      <tr>
        <th>Título</th>
        <th>Ativo</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {#each list as banner}
        <Item { banner } />
      {/each}
    </tbody>
  </table>
</div>